import React from "react";
import { Box, Stack, Typography, Chip } from "@mui/material";
import { Images } from "./../../assets/common";
import { useTranslation } from "react-i18next";
export default function PrivateAssetRow({ data, type }) {
  const { t } = useTranslation("common");
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <img
        className="avatar"
        src={
          data["thumbnailImg"] ? data["thumbnailImg"]["filePath"] : Images.album
        }
        alt="music"
      />
      <Stack sx={{ margin: "0 auto 0 10px" }}>
        <Typography className="fs-14">{data["title"]}</Typography>
        {data["songs"] ? (
          <Typography className="fs-12 light-text">
            {`${data["songs"]} ${t("myMusic.songs")}`}
          </Typography>
        ) : null}
      </Stack>
      <Stack direction="column" alignItems="end">
        <Chip
          sx={{
            width: "80px",
            height: "24px",
            fontStyle: "italic",
            fontSize: "12px",
            color: "#ffffff",
            backgroundColor: "#FFFFFF13",
          }}
          label={type}
        />
        {data["nftId"] ? (
          <Typography
            sx={{
              textAlign: "right",
              fontStyle: "italic",
              fontSize: "12px",
              color: "#ffffff80",
            }}
            className="fs-14"
          >
            {t("noData.message18")}
          </Typography>
        ) : null}
      </Stack>
    </Stack>
  );
}
